import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useSelector } from 'react-redux'
import { Intent, Spinner } from "@blueprintjs/core";

import { authSelector, userSelector } from '../store';
import { authProvider } from '../auth';

import CourseSidebar from '../Blocks/LessonPart/CourseSidebar';
import LessonPartContent from '../Blocks/LessonPart/LessonPartContent';
import NightModeButton from '../Components/NightModeButton';
import { nightModeSelector } from '../store';

import MyMenu from '../Blocks/Header/MyMenu';
import LanguageSelector from '../Components/LanguageSelector';


function LessonPartPage() {
  let { id, le_id, lp_id } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const [course, setCourse] = useState(null);
  const [lessonPart, setLessonPart] = useState(null);
  const [curriculum, setCurriculum] = useState([]);
  const nightMode = useSelector(nightModeSelector);

  const user = useSelector(userSelector);
  const auth = useSelector(authSelector);

  useEffect(() => {
    let cancelled = false;
    setIsLoaded(false);
    Promise.all([
      authProvider.request(auth, "get", `/api/courses/${id}/`),
      authProvider.request(auth, "get", `/api/courses/${id}/lessons/${le_id}/lesson_parts/${lp_id}/`),
    ]).then(([courseRes, lessonPartRes]) => {
      if (cancelled) return;
      setCourse(courseRes.data);
      setLessonPart(lessonPartRes.data);
      setIsLoaded(true);
    }).catch(() => {
      if (cancelled) return;
      setIsLoaded(true);
    });
    return () => { cancelled = true; };
  }, [auth, id, le_id, lp_id]);

  useEffect(() => {
    authProvider.request(auth, "get", `/api/courses/${id}/curriculum/`)
      .then(res => setCurriculum(res.data))
      .catch(() => {});
  }, [auth, id]);

  const handleMarkWatched = (lp_id) => {
    setCurriculum(prev => prev.map(lesson => ({
      ...lesson,
      lesson_parts: lesson.lesson_parts.map(lp =>
        lp.id === lp_id ? { ...lp, passed: true } : lp
      ),
    })));
  };

  const currentLesson = { id: parseInt(le_id) };

  return (
    <div id="wrapper" className={nightMode ? "night-mode" : ""}>
      <div className="course-layouts">
        <div className="course-content bg-dark">
          <div className="course-header">
            <a href="#none" className="btn-back" uk-toggle="target: .course-layouts; cls: course-sidebar-collapse">
              <i className="icon-feather-chevron-left"></i>
            </a>

            <h4 className="text-white">{lessonPart ? lessonPart.title : ""}</h4>
            <div>
              <LanguageSelector />

              <a href="#none">
                <i className="icon-feather-help-circle btns"></i>
              </a>
              {course && (
                <div uk-drop="pos: bottom-right;mode : click">
                  <div className="uk-card-default p-4">
                    <h4>{course.title}</h4>
                    <p className="mt-2 mb-0">{course.description}</p>
                  </div>
                </div>
              )}

              <a href="#none">
                <i className="icon-feather-more-vertical btns"></i>
              </a>

              { user ?
                <MyMenu />
                :
                <div className="dropdown-option-nav " uk-dropdown="pos: bottom-right ;mode : click">
                  <ul>
                    <li>
                      {course && <a href={`/course/${course.slug}/`}>Course details</a>}
                    </li>
                    <li>
                      <NightModeButton />
                    </li>
                  </ul>
                </div>
              }
            </div>
          </div>

          <div className="course-content-inner">
            {isLoaded && course && lessonPart
              ? <LessonPartContent course={course} lesson={currentLesson} lesson_part={lessonPart} opUpdateLessonPart={handleMarkWatched} />
              : <Spinner intent={Intent.PRIMARY} />
            }
          </div>
        </div>

        <CourseSidebar curriculum={curriculum} />
      </div>
    </div>
  );
}


export default LessonPartPage;
